import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import ButtonPageSelection from '../../../components/Editor/ButtonPageSelection';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			slider: { totalPages },
			combo: { isCombining },
			pageSelection: { isActive },
		},
	} = state;

	return {
		isActive,
		isDisabled: totalPages === 1 || isCombining,
	};
};

export default connect(mapStateToProps)(ButtonPageSelection);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ButtonPageSelection/index.tsx